import { Controller } from "@hotwired/stimulus"

import 'bootstrap-table/dist/bootstrap-table'
import 'bootstrap-table/dist/extensions/mobile/bootstrap-table-mobile'
import 'bootstrap-table/dist/locale/bootstrap-table-pt-BR'

import '../src/tableExport'
import 'bootstrap-table/dist/extensions/export/bootstrap-table-export'

import { tooltips } from "../src/functions"

// Connects to data-controller="bootstrap-table"
export default class extends Controller {
  connect() {
    $(this.element.querySelector('.bootstrap-table-mobile')).bootstrapTable({
      mobileResponsive: true,
      checkOnInit: true,
      classes: 'table table-striped table-hover table-borderless table-borderless mb-0'
    })
    $(this.element.querySelector('.bootstrap-table-mobile-with-export')).bootstrapTable({
      checkOnInit: true,
      classes: 'table table-striped table-hover table-bordered table-borderless mb-0',
      showExport: true,
      striped: true,
      mobileResponsive: true,
      exportTypes: ['csv', 'json', 'doc', 'sql', 'txt', 'excel', 'xml'],
      formatNoMatches: function () {
        return $(this).attr('noMatchesMessage') || "Nenhum registro encontrado"
      }
    })
    tooltips()
  }

  disconnect() {
    $(this.element.querySelector('.bootstrap-table-mobile')).bootstrapTable('destroy')
    $(this.element.querySelector('.bootstrap-table-mobile-with-export')).bootstrapTable('destroy')
  }
}
